import { memo } from 'react';
import cn from 'classnames';
import { Radio, RadioGroup } from '@creditflowresearch/uilib/Radio';
import usePerpetualFilter from './usePerpetualFilter';

import styles
  from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/styles/radioGroup.module.scss';
import spaceStyles from '@creditflowresearch/uilib/styles/helpers/spaces.module.scss';

const PerpetualTranches = memo(() => {
  const { selectedValue, onChange, options } = usePerpetualFilter();

  return (
    <RadioGroup
      name="perpetualTranches"
      dataTest="perpetualTranchesRadioGroup"
      selectedValue={ selectedValue }
      onChange={ onChange }
      label="Perpetual Tranches"
      isNarrow
      className={ cn(styles.radioGroup, spaceStyles.mtl) }
    >
      { options.map((option) => (
        <Radio
          key={ option.value }
          value={ option.value }
          label={ option.label }
          dataTest={ `radio-perpetual-${ option.value }` }
        />
      )) }
    </RadioGroup>
  );
});

export default PerpetualTranches;
